import Vue from 'vue'
import { Select, Option, Cascader, Table, TableColumn, Input, Pagination, SkeletonItem, Skeleton, Image,Popover } from 'element-ui'
Vue.use(Option)
Vue.use(Select)
Vue.use(Cascader)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(Pagination)
Vue.use(Skeleton)
Vue.use(Image)
Vue.use(SkeletonItem)
Vue.use(Popover)